module.exports = __webpack_public_path__ + "static/messenger-groups-8d7ebdab7436716def9d76b6bb790420.png";